import { render } from "./OwnersList.vue?vue&type=template&id=16308507"
import script from "./OwnersList.vue?vue&type=script&lang=js"
export * from "./OwnersList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__